import { useSsSelector } from '~SpectateStore';
import { selectSportSlugByEventId } from '~SpectateStore/selectors/sportsSelectors';

export const useSportSlugByEventId = eventId => useSsSelector(state => selectSportSlugByEventId(state, eventId));
